import { render, staticRenderFns } from "./InvoiceRecord.vue?vue&type=template&id=0d2b77fb&scoped=true"
import script from "./InvoiceRecord.vue?vue&type=script&lang=js"
export * from "./InvoiceRecord.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRecord.vue?vue&type=style&index=0&id=0d2b77fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2b77fb",
  null
  
)

export default component.exports